'use client';

import { FC, useEffect, useState } from 'react';
import Image from 'next/image';

import Heading, {
  HeadingTag,
  HeadingSize,
} from '@/components/ui/Heading/Heading';
import { useIsDesktop } from '@/hooks/useIsDesktop';
import { TypeWhatIsItFields } from '@/core/generated-types';
import Bullet from './Bullet';

export const WhatIsIt: FC<TypeWhatIsItFields> = ({
  desktopImages = [],
  mobileImages = [],
  header,
  bullet1,
  bullet2,
  bullet3,
  shippingNote,
}) => {
  const isDesktop = useIsDesktop();
  const [hydrated, setHydrated] = useState(false);

  useEffect(() => {
    setHydrated(true);
  }, []);

  const imagesByBreakpoint = isDesktop ? desktopImages : mobileImages;

  return (
    <div className="flex flex-col lg:flex-row items-center">
      <div className="order-last lg:order-first lg:w-1/2 px-6 py-8 lg:pr-28 md:pl-10">
        <div className="max-w-[500px] justify-self-end">
          <Heading
            tag={HeadingTag.H1}
            size={HeadingSize.H1}
            text={header}
            classes="mb-6 xl:mb-[50px]"
          />
          <ul className="flex flex-col gap-4 xl:gap-6 md:mb-8 xl:mb-16">
            <Bullet>{bullet1}</Bullet>
            <Bullet>{bullet2}</Bullet>
            <Bullet>{bullet3}</Bullet>
          </ul>
          <div className="flex justify-start">
            <div className="flex justify-center items-center p-4 border-2 border-lime-green rounded-md max-w-[450px]">
              <Image
                className="mr-8 w-[60px] h-auto"
                src="https://images.ctfassets.net/0sea1vycfyqy/6c7MzhtuLBmb6838cGjvut/ee23f67edd0e5ab4e3448de9a5c781da/Truck.png"
                alt="desktop truck"
                width={60}
                height={60}
                loading="lazy"
              />
              <p className="font-bold text-d-sm">{shippingNote}</p>
            </div>
          </div>
        </div>
      </div>
      <div className="lg:w-1/2 lg:aspect-square bg-slate-300">
        {hydrated &&
          imagesByBreakpoint?.map((item, index) => (
            <div key={index} className="w-full h-full">
              <Image
                alt={item.fields?.Image.fields.description}
                width={item.fields?.Image?.fields?.file?.details.image?.width}
                height={item.fields?.Image?.fields?.file?.details.image?.height}
                src={`https:${item.fields?.Image?.fields?.file?.url}`}
                quality={75}
                loading="lazy"
              />
            </div>
          ))}
      </div>
    </div>
  );
};

export default WhatIsIt;
